<template>
  <div class="cargo-ag-grid-dimension-editor">
    <el-input
      v-model.number="sizeLength"
      type="number"
      size="mini"
      data-index="sizeLength"
      @input="handleChange"
    />
    <span>*</span>
    <el-input
      v-model.number="sizeWidth"
      type="number"
      size="mini"
      data-index="sizeWidth"
      @input="handleChange"
    />
    <span>*</span>
    <el-input
      v-model.number="sizeHeight"
      type="number"
      size="mini"
      data-index="sizeHeight"
      @input="handleChange"
    />
    <span>*</span>
    <el-input
      v-model.number="sizeQuantity"
      type="number"
      size="mini"
      data-index="sizeQuantity"
      @input="handleChange"
    />
  </div>
</template>

<script>
import Vue from 'vue'
export default Vue.extend({
  name: 'CargoAgGridDimensionEditor',
  data() {
    return {
      custom: null,
      valueChanged: null,
      sizeLength: 0,
      sizeWidth: 0,
      sizeHeight: 0,
      sizeQuantity: 0
    }
  },
  created() {
    this.custom = this.params
    this.sizeLength = Number(this.custom.data.sizeLength)
    this.sizeWidth = Number(this.custom.data.sizeWidth)
    this.sizeHeight = Number(this.custom.data.sizeHeight)
    this.sizeQuantity = Number(this.custom.data.sizeQuantity)
    this.valueChanged = this.custom.valueChanged
  },
  methods: {
    handleChange() {
      this.custom.data.sizeLength = Number(this.sizeLength)
      this.custom.data.sizeWidth = Number(this.sizeWidth)
      this.custom.data.sizeHeight = Number(this.sizeHeight)
      this.custom.data.sizeQuantity = Number(this.sizeQuantity)
      this.valueChanged(this.custom)
    }
  }
})
</script>

<style lang="scss" scoped>
.cargo-ag-grid-dimension-editor {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  box-sizing: border-box;
  padding: 2px 10px;
  .el-input {
    height: 24px;
    line-height: 24px;
    /deep/ .el-input__inner {
      height: 24px;
      text-align: right;
    }
  }
  span {
    height: 24px;
    line-height: 30px;
    font-size: 18px;
  }
}
</style>
